import React, { FC } from 'react';
import { DetailsColumn, Name } from './BookableListItem.styles';
import { DescriptionClipper } from './DescriptionClipper';
import { LoggedErrorBoundary } from '@common/components/ErrorBoundary/LoggedErrorBoundary';

type ItemDetailsProps = {
  title: string;
  description: string;
  terms: string;
};

export const ItemDetails: FC<ItemDetailsProps> = ({ title, description, terms }) => {
  return (
    <DetailsColumn>
      <Name>{title}</Name>
      <LoggedErrorBoundary>
        {description && (
          <DescriptionClipper
            description={description}
            terms={terms}
            options={{ maxLength: 240, maxLines: 5 }}
          />
        )}
      </LoggedErrorBoundary>
    </DetailsColumn>
  );
};
